<template>
  <filter-menu v-bind="$props">
    <template
      v-if="isDatePicker"
      #items
    >
      <date-picker
        :class="datePicker.classes"
        v-bind="datePickerConfig"
        v-on="datePicker.on"
      />
    </template>
    <template
      v-else-if="isLocationSearch"
      #items
    >
      <icon-location-pin-fill
        inherit-color
        class="location-search__icon"
      />
      <location-search
        :class="locationFacet.classes"
        data-ui-add-location-btn="add-location-btn"
        data-ui-change-location-btn="facet-change-location-btn"
        v-bind="locationSearchConfig"
        v-on="locationFacet.on"
      />
    </template>
    <template
      v-else-if="isLocationsASearch"
      #items
    >
      <filter-link-list v-bind="locationsASearchConfig">
        <filter-link
          v-for="item in items"
          :key="item.key"
          :expanded="expanded"
          v-bind="item"
          filter-class="filter-link--locations"
        />
      </filter-link-list>
    </template>
    <template
      v-else-if="isCollapsableLinkedList"
      #items
    >
      <collapsable-filter-link-list v-bind="collapsableLinkedListConfig" />
    </template>
    <template
      v-else
      #items
    >
      <filter-link-list v-bind="defaultConfig">
        <filter-link
          v-for="item in items"
          :key="item.key"
          v-bind="item"
          :expanded="expanded"
        />
      </filter-link-list>
    </template>
  </filter-menu>
</template>

<script>
import { IconLocationPinFill } from '@rei/cedar';
import { FilterMenu, FilterLink, FilterLinkList } from '@rei/search-page';
import { LocationSearch } from '@rei/location-search';
import CollapsableFilterLinkList from './CollapsableFilterLinkList.vue';
import {
  FACETS_LOCATION_NAME,
  FACETS_LOCATION_API,
  FACETS_LOCATION_REGEX_IS_VALID,
  FACETS_ACTIVITIES_NAME,
} from '../../common/search-constants';

export default {
  name: 'FilterMenuComponent',
  components: {
    IconLocationPinFill,
    FilterMenu,
    FilterLink,
    FilterLinkList,
    LocationSearch,
    CollapsableFilterLinkList,
  },
  props: {
    collapsable: {
      type: Boolean,
      required: true,
    },
    datePicker: {
      type: Object,
      required: true,
    },
    locationFacet: {
      type: Object,
      required: true,
    },
    collapsableLinkList: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    toggle: {
      type: Function,
      required: true,
    },
  },
  computed: {
    isLocationSearch() {
      const { name } = this;
      return name === FACETS_LOCATION_NAME;
    },
    isLocationsASearch() {
      const { name } = this;
      return name === 'locations_a';
    },
    isDatePicker() {
      return this.name === 'classes_date_range';
    },
    isCollapsableLinkedList() {
      return this.name === FACETS_ACTIVITIES_NAME;
    },
    defaultConfig() {
      const { items, expanded } = this;
      return {
        expanded,
        'max-length': items.length + 1,
      };
    },
    datePickerConfig() {
      const { datePicker } = this;
      const config = {
        showShortcutsMenuTrigger: false,
        fullscreenMobile: true,
        offsetY: 10,
        showMonthYearSelect: true,
        changeDatesLabel: 'Change dates',
        triggerLabel: 'Select date range',
        ...datePicker.props,
      };
      return config;
    },
    locationSearchConfig() {
      const { locationFacet } = this;
      return {
        class: 'mobile-only',
        label: null,
        autocompleteFetchUrl: FACETS_LOCATION_API,
        autocompleteDelay: 200,
        googleApiKey: 'AIzaSyAIG3db8X-64gITBmCx7WekuKrYrOLvg7k',
        removeLocationEnabled: true,
        validation: true,
        validationPattern: FACETS_LOCATION_REGEX_IS_VALID,
        ...locationFacet.props,
      };
    },
    locationsASearchConfig() {
      const { expanded } = this;
      return {
        expanded,
      };
    },
    collapsableLinkedListConfig() {
      const { name, expanded, items, collapsableLinkList } = this;

      return {
        useShowMore: false,
        maxLength: items.length + 1,
        filterName: name,
        parentExpanded: expanded,
        expandedItems: collapsableLinkList.getExpandedItems(name),
        items,
        ...collapsableLinkList.props,
      };
    },
  },
};
</script>

<style lang="scss">
@use '@/style/components/search/filters-component.scss';
@use '@/style/components/search/location-search-facet.scss';
</style>

<style lang="scss" scoped>
@use '@/style/components/search/filter-menu-component.scss';
</style>
